import React from 'react'
import { Box, Button, Card, CardContent, Grid, Typography } from '@material-ui/core'

import { Batch, Case, Sku } from '../../api/models'
import { QuerySelectField } from 'src/forms'
import { useQueryPaginator } from 'src/components/Table'
import { skuit } from 'src/services/skuit'

import { BatchDialog } from 'src/modules/supply_chain/components/BatchDialog'

interface SkuCardProps {
  item: Sku
  selectedCase?: Case
  selectCase?: (from?: Case, to?: Case) => void
  selectedBatch?: Batch
  selectBatch?: (from?: Batch, to?: Batch) => void
}

export const SkuCard = (props: SkuCardProps) => {
  const { item, selectedCase, selectCase, selectBatch, selectedBatch } = props

  const handleSelectBatch = (batch: Batch) => {
    if (selectBatch && selectedBatch?.guid !== batch?.guid) {
      selectBatch(selectedBatch, batch)
    }
  }
  const batchPaginator = useQueryPaginator(
    'batch-list',
    skuit.sc.batches.list,
  )
  const Icon = item.icon
  return (
    <Card>
      <CardContent>
        <Typography>
          <Icon /> {item.typeDisplay}
        </Typography>
        <Grid container>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">SquID:</Box>
            </Grid>
            <Grid item>{item.guid}</Grid>
          </Grid>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">SKU:</Box>
            </Grid>
            <Grid item>{item.sku}</Grid>
          </Grid>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">SKU:</Box>
            </Grid>
            <Grid item>{item.productName || item.product.name}</Grid>
          </Grid>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">Cases:</Box>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant={selectedCase ? 'outlined' : 'contained'}
                onClick={() => {
                  if (selectCase && selectedCase) {
                    selectCase(selectedCase, undefined)
                  }
                }}
              >
                x1
              </Button>
              {item.product.cases?.map((productCase) => (
                <Button
                  key={productCase.guid}
                  size="small"
                  variant={selectedCase?.guid === productCase.guid ? 'contained' : 'outlined'}
                  onClick={() => {
                    if (selectCase && selectedCase?.guid !== productCase.guid) {
                      selectCase(selectedCase, productCase)
                    }
                  }}
                >
                  x{productCase.numUnits}
                </Button>
              ))}
            </Grid>
          </Grid>
          <Grid item container spacing={6} xs={12}>
            <Grid item>
              <Box fontWeight="bold">Batch:</Box>
            </Grid>
            <Grid item xs={4}>
              <QuerySelectField
                name="batch"
                label="Batch"
                paginator={batchPaginator}
                onSelected={handleSelectBatch}
                CreateDialog={(props) => {
                  return <BatchDialog {...props} allowSelectASN={false}/>
                }}
                createOnSave={(batch: Batch) => {
                  batchPaginator.refresh()
                  handleSelectBatch(batch)
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
